import { create } from 'zustand';

/**
 * Help-overlay open state — a tiny shared flag so that HotkeyScopeSync stays the
 * SOLE writer of the `global` hotkey scope (single-writer invariant).
 *
 * KeyboardHelpOverlay mirrors its local `open` state here instead of toggling
 * the scope itself. HotkeyScopeSync reads `open` and folds it into its
 * `overlayOpen` condition, so help-overlay is just one more reason `global` is
 * suppressed — and it can never re-enable `global` out from under an open
 * drawer/modal (the regression this store exists to prevent).
 */
interface HelpOverlayState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useHelpOverlayStore = create<HelpOverlayState>(set => ({
  open: false,
  setOpen: open => set({ open }),
}));
